export { default } from './GeoChart.component';
export type { GeoChartProps } from './GeoChart.component';
